/* eslint-disable no-console */
import { useTranslation } from 'next-i18next';
import React from 'react';

import AddOrEditModal from '@/modules/workingDayReconciliation/components/CrewLevel/DetailedCard/Modal/AddOrEditModal';
import DeleteModal from '@/modules/workingDayReconciliation/components/CrewLevel/DetailedCard/Modal/DeleteModal';
import { tableColumns } from '@/modules/workingDayReconciliation/components/CrewLevel/DetailedCard/Modal/ExpensesModal/ListingTable/logic';
import { IReconciliation } from '@/modules/workingDayReconciliation/types';
import { NextImage, Table } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

interface Props {
  list: IReconciliation.IGetWorkdayBonusesTable[];
  modalType: IReconciliation.IModalType;
  currentSupplierSummary: IReconciliation.IGetWorkdaySummary | null;
}

const ListingTable: React.FC<Props> = ({
  list,
  modalType,
  currentSupplierSummary,
}) => {
  const { openModal } = useModal();
  const [selectedAsset] = useStore((store) => store?.asset);

  const { t } = useTranslation('common');

  const handleAttachmentClick = (attachmentUrl: string | null) => {
    attachmentUrl &&
      openModal(
        <div className='relative h-[420px] w-[600px]  bg-primary-100'>
          <NextImage
            fill
            className='h-full w-full'
            useSkeleton
            alt='image'
            src={attachmentUrl}
          />
        </div>
      );
  };
  const handleEditButton = (
    rowData: IReconciliation.IGetWorkdayBonusesTable
  ) => {
    openModal(
      <AddOrEditModal
        operationType='edit'
        expenseType={modalType}
        entityId={selectedAsset?.id}
        defaultData={rowData}
        currentSupplierSummary={currentSupplierSummary}
      />,
      {
        title: t(`edit-${modalType}`),
      }
    );
  };
  const handleCancelButton = (
    expenseId: number,
    expenseType: IReconciliation.IExpenseType
  ) => {
    openModal(
      <DeleteModal
        modalType={modalType}
        expenseId={expenseId}
        expenseType={expenseType}
      />
    );
  };

  return (
    <div className='-mr-24 mb-48 mt-24 max-w-[90vw]'>
      <Table<IReconciliation.IGetWorkdayBonusesTable>
        selection={false}
        rowContainerClassNameFu={(row) =>
          row.isIssued ? '' : 'bg-background-default'
        }
        columns={tableColumns(
          t,
          modalType,
          handleAttachmentClick,
          handleEditButton,
          handleCancelButton,
          selectedAsset?.currency || '',
          currentSupplierSummary?.issuedPayment
        )}
        data={list}
        pagination={false}
      />
    </div>
  );
};
export default ListingTable;
